import { getDefaultUserStoreState } from './state/query-hooks/use-user';

export interface InitialApolloStoreState {
  user: any;
}

const initStore = (): InitialApolloStoreState => ({
  user: getDefaultUserStoreState(),
});

export default initStore;
